import simbApi from ".";
import { GET_SHARED_ITEMS_BOARD_VIEW } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const getSharedItemsBoardView = async (access_token: string, currentBoard: number, page: number, limit: number, filterQuery: string) => {
  try {
    const response = await simbApi.post(
      GET_SHARED_ITEMS_BOARD_VIEW,
      {
        currentBoard: currentBoard,
        page: page,
        limit: limit,
        filter: filterQuery,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};

export const getJobStatus = async (access_token: string, jobId: string) => {
  try {
    const response = await simbApi.get(`/simb/job-status/${jobId}`, {
      headers: { Authorization: `Bearer ${access_token}` },
    });

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response?.data;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};

export const getSyncItemValues = async (access_token: string, syncId: string) => {
  try {
    const response = await simbApi.post(
      "/simb/sync-item-values",
      { syncId },
      { headers: { Authorization: `Bearer ${access_token}` } },
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response?.data?.data ?? null; // the single-syncId discrepancy result (with items/values)
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
